/**
 * `404 TENANT_NOT_FOUND` on any per-tenant call (H §4.5): the tenant is no longer assigned to
 * this reseller (or never was). `client.ts` reports it here for every
 * `/v1/reseller-admin/tenants/{slug}/…` call, so BusinessLayout can reload the tenant under `/business` — whichever
 * screen, hook or dialog made the call, and even when that caller swallows the error.
 */

type Listener = (slug: string) => void;

const listeners = new Set<Listener>();

const TENANT_PATH = /^\/v1\/reseller-admin\/tenants\/([^/?]+)/;

/** The tenant slug a tmm-api path names, or `null` when it is not a per-tenant path. */
export function tenantSlugOfPath(path: string): string | null {
  const match = TENANT_PATH.exec(path);
  if (!match?.[1]) return null;
  try {
    return decodeURIComponent(match[1]);
  } catch {
    return null;
  }
}

export function reportTenantGone(slug: string): void {
  for (const listener of [...listeners]) listener(slug);
}

/** Listen for a gone tenant; returns the unsubscribe. */
export function onTenantGone(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
